
/**
 * 
 * @hidden
 */
export enum ColumnFilterTypes {

    /**
     * 
     */
    None = 0,

    /**
     * 
     */
    Text = 1,

    /**
     * 
     */
    DropDown = 2,
}
